module.exports = __webpack_public_path__ + "static/media/nav-icon-reports-active.925365d1.svg";